import { RiCloseLine } from "react-icons/ri";

const ModalWrapper = ({ title, onClose, children, maxWidth = "max-w-2xl" }) => (
  <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
    <div
      className={`bg-white rounded-2xl w-full ${maxWidth} max-h-[90vh] overflow-y-auto border border-gray-300 shadow-xl`}
    >
      <div className="sticky top-0 bg-white p-4 border-b border-gray-300 flex justify-between items-center z-10">
        <h2 className="text-xl font-bold text-primaryTextColor">{title}</h2>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-primaryBtnHoverColor"
        >
          <RiCloseLine size={24} />
        </button>
      </div>
      <div className="p-6">{children}</div>
    </div>
  </div>
);

export default ModalWrapper;
